// src/pages/ExpenseRecognitionRecord/components/exportExpenseRecognitionCsv.js
import { formatToCompanyTimezone } from "../../../lib/functions";
import dayjs from "dayjs";

const escape = (val) => {
  const str = String(val ?? "");
  return str.includes(",") || str.includes('"') || str.includes("\n")
    ? `"${str.replace(/"/g, '""')}"`
    : str;
};

const fmtNum  = (val) => Number(val || 0).toFixed(2);
const fmtDate = (v)   => (v ? formatToCompanyTimezone(v).split(" ")[0] : "-");
const fmtDateAlt = (v) => (v ? dayjs(v).format("DD-MM-YYYY") : "-");

/**
 * @param {object} params
 * @param {Array}   params.list     - rows from Redux state.expenseRecognition.list
 * @param {object}  params.filters  - for recordType check
 * @param {string}  params.title
 * @param {string}  params.filename
 */
export const exportExpenseRecognitionCsv = ({
  list,
  filters,
  title    = "Expense Recognition Record",
  filename = "expense_recognition_record",
}) => {
  const isWithDetails = filters?.recordType === "with details";
  const rows = [[title], []];

  if (isWithDetails) {
    // ── With Details: master row + indented detail rows ───────
    const headers = [
      "No.", "Date", "Description", "Status", "Entry By", "Total Amount",
      // detail sub-columns (offset right)
      "  Sl No.", "  Expense Head", "  Remark / Particulars", "  Amount",
    ].map(escape);

    rows.push(headers);

    let grandTotal = 0;

    list.forEach((row, i) => {
      const subtotal = (row.details || []).reduce(
        (s, d) => s + Number(d.amount || 0), 0
      );
      grandTotal += subtotal;

      // Master row
      rows.push([
        i + 1,
        fmtDateAlt(row.date),
        row.description || "",
        row.status      || "",
        row.createdBy   || "",
        fmtNum(subtotal),
        "", "", "", "",
      ].map(escape));

      // Detail rows
      (row.details || []).forEach((d, di) => {
        rows.push([
          "", "", "", "", "", "",
          di + 1,
          d.description || "",
          d.remark      || "",
          fmtNum(d.amount),
        ].map(escape));
      });

      // Sub-total row
      rows.push([
        "", "", "", "", "", "",
        "", "", "Sub Total:", fmtNum(subtotal),
      ].map(escape));

      rows.push(Array(10).fill("").map(escape)); // blank spacer
    });

    rows.push([]); // spacer
    rows.push([
      "Grand Total:", "", "", "", "", fmtNum(grandTotal),
      "", "", "", "",
    ].map(escape));

  } else {
    // ── Without Details: flat table ───────────────────────────
    const headers = [
      "No.", "Date", "Entry By", "Status", "Description", "Total Amount",
    ].map(escape);

    rows.push(headers);

    const grandTotal = list.reduce((s, r) => s + Number(r.total || 0), 0);

    list.forEach((row, i) => {
      rows.push([
        i + 1,
        fmtDate(row.date),
        row.createdBy   || "",
        row.status      || "",
        row.description || "",
        fmtNum(row.total),
      ].map(escape));
    });

    rows.push([]); // spacer
    rows.push(["Grand Total:", "", "", "", "", fmtNum(grandTotal)].map(escape));
  }

  const csv  = rows.map((r) => r.join(",")).join("\n");
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
  const url  = URL.createObjectURL(blob);
  const a    = document.createElement("a");
  a.href     = url;
  a.download = `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};